import { render, staticRenderFns } from "./uploadURL-editor.vue?vue&type=template&id=2b299867&scoped=true&"
import script from "./uploadURL-editor.vue?vue&type=script&lang=js&"
export * from "./uploadURL-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b299867",
  null
  
)

export default component.exports